export default __webpack_public_path__ + "static/media/sd-print-PT.39834568.jpg";